// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-dropdown .country .country-name,
.custom-dropdown .country .country-flag {
 
  width:30px;
}
.custom-dropdown .country .country-iso {
    margin-left: 0; /* Adjust the styling to center the country code */
    width:30px;
  }
  .custom-dropdown .country .country-flag {
    display: none;
  }
  
  .custom-dropdown .country .country-iso {
    display: none;
  }
  .custom-datatable .pagination .react-bootstrap-table-pagination-list .dropdown-toggle::after {
    display: none;
}
.custom-datatable .react-bootstrap-table-pagination .dropdown-toggle.dropdown-toggle-split span {
  display: none;
}
.custom-datatable .react-bootstrap-table-pagination .dropdown-toggle::after {
  content: none;
}
.custom-datatable .react-bootstrap-table-pagination .dropdown-toggle,
.custom-datatable .react-bootstrap-table-pagination .pagination-page-info {
  display: none;
}

`, "",{"version":3,"sources":["webpack://./src/pages/HotelOnBoarding/hotel.css"],"names":[],"mappings":"AAAA;;;EAGE,UAAU;AACZ;AACA;IACI,cAAc,EAAE,kDAAkD;IAClE,UAAU;EACZ;EACA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;EACA;IACE,aAAa;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;;EAEE,aAAa;AACf","sourcesContent":[".custom-dropdown .country .country-name,\n.custom-dropdown .country .country-flag {\n \n  width:30px;\n}\n.custom-dropdown .country .country-iso {\n    margin-left: 0; /* Adjust the styling to center the country code */\n    width:30px;\n  }\n  .custom-dropdown .country .country-flag {\n    display: none;\n  }\n  \n  .custom-dropdown .country .country-iso {\n    display: none;\n  }\n  .custom-datatable .pagination .react-bootstrap-table-pagination-list .dropdown-toggle::after {\n    display: none;\n}\n.custom-datatable .react-bootstrap-table-pagination .dropdown-toggle.dropdown-toggle-split span {\n  display: none;\n}\n.custom-datatable .react-bootstrap-table-pagination .dropdown-toggle::after {\n  content: none;\n}\n.custom-datatable .react-bootstrap-table-pagination .dropdown-toggle,\n.custom-datatable .react-bootstrap-table-pagination .pagination-page-info {\n  display: none;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
